import type { AgendaItem } from "@repo/types";
import { ExportAgendaItemForm } from "./ExportAgendaItemForm";
import { ExportDialog } from "../common/ExportDialog";

export interface ExportAgendaItemDialogProps {
  getAgendaItems: () => AgendaItem[];
  getPreselectedFields: () => string[];
}

export const ExportAgendaItemDialog = ({
  getAgendaItems,
  getPreselectedFields,
}: ExportAgendaItemDialogProps) => {
  return (
    <ExportDialog
      title="Export Agenda Items"
      ExportForm={({ onCancel }) => (
        <ExportAgendaItemForm
          getAgendaItems={getAgendaItems}
          getPreselectedFields={getPreselectedFields}
          onCancel={onCancel}
        />
      )}
    />
  );
};
